/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * 
 * @export
 * @enum {string}
 */

export const ExportFormat = {
    SHP: 'SHP',
    KML: 'KML',
    DGN: 'DGN',
    JSON: 'JSON',
    DXF: 'DXF',
    XLSX: 'XLSX'
} as const;

export type ExportFormat = typeof ExportFormat[keyof typeof ExportFormat];



